export default {
  header: {
    login: 'Log in',
    freeTrial: 'Try for free',
  },
  share: {
    title: 'Share your files',
    subtitle: 'A private link, ready to send — no download needed to view.',
  },
  freeTier: {
    note: 'Free · no account · up to 2 GB · 10 min video · 7-day links',
  },
  prepare: {
    file: '{count} file | {count} files',
    filesTitle: 'Files',
    addMore: 'Add files',
    send: 'Send',
    uploading: 'Uploading… {progress}%',
    uploadFailed: 'Upload failed',
    retry: 'Retry upload',
    remove: 'Remove file',
  },
  form: {
    tabLink: 'Link',
    tabEmail: 'Email',
    createLink: 'Create link',
    shareName: 'Share name (optional)',
    shareNamePlaceholder: 'E.g.: Project photos',
    shareTitle: 'Share title',
    shareTitlePlaceholder: 'E.g.: Project photos 2026',
    emailSoon: 'Email delivery is coming soon — share the link for now.',
  },
  link: {
    copy: 'Copy link',
    copied: 'Copied!',
    open: 'Open',
  },
  settings: {
    noPassword: 'No password',
    withPassword: 'Password protected',
    expirationLabel: 'Expiration',
    expirationHint: 'Free links last up to 7 days.',
    passwordLabel: 'Password protection',
    passwordHint: 'Require a password to open the link.',
    downloadLabel: 'Allow download',
    downloadHint: 'Off = view-only, right in the player.',
    passwordPlaceholder: 'Set a password',
    passwordMinLength: 'Use at least 4 characters.',
    expiration: {
      '1': '1 day',
      '3': '3 days',
      '7': '7 days',
    },
    accountBadge: 'Account',
    emailSend: 'Send by email',
    emailSendHint: 'Email this share straight to your contacts.',
    longer: 'Keep links longer',
    longerHint: 'Set any duration — your files never auto-expire.',
    stats: 'See who viewed',
    statsHint: 'Track views and downloads in real time.',
  },
  success: {
    upsellTitle: 'Create a free account to go further',
    upsellSubtitle: 'See who viewed · keep links beyond 7 days · lift the limits',
    upsellCta: 'Create my free account',
  },
  loading: {
    link: 'Creating your link…',
    email: 'Sending…',
    linkSub: 'Securing your share and getting your link ready.',
    emailSub: 'Preparing delivery to your recipients.',
  },
  result: {
    titleLink: 'Your link is ready',
    titleEmail: 'Emails sent',
    justNow: 'just now',
    sentTo: 'Sent to',
    expiration: 'Expiration',
    noExpiration: 'No expiry',
    views: 'Views & history',
    viewsGated: 'With an account',
    access: 'Access',
    accessPublic: 'Public',
    accessProtected: 'Password',
    download: 'Download',
    downloadOn: 'Allowed',
    downloadOff: 'View-only',
    shareVia: 'Share via',
    shareText: 'I sent you files with Videas',
    shareSubject: 'Files shared with Videas',
    qrLabel: 'Scan this QR code to open the share on a phone.',
    newShare: 'New share',
  },
  demo: {
    title: 'This is a demo',
    message: 'Create a free Videas account to share your files securely.',
    cta: 'Try for free',
  },
  errors: {
    createFailed: 'Failed to create the link. Please try again.',
    tooLarge: '{name} is over the 2 GB free limit.',
    tooLong: '{name} is over the 10 min free limit.',
  },
  empty: {
    title: 'Share your files securely',
    subtitle: 'Upload files to get started.',
  },
  subtitles: {
    transcribing: {
      title: 'Generating your subtitles…',
      subtitle: 'Our AI is transcribing {name}.',
      note: 'No account needed to see the result',
      steps: {
        received: 'Receiving the file',
        audio: 'Extracting the audio track',
        transcript: 'Transcribing and aligning words',
        cues: 'Splitting into subtitles',
      },
      eta: 'Around {time} left',
      etaSeconds: '{count} s',
      etaMinutes: '{count} min',
      etaUnknown: 'Estimating time left…',
    },
    editing: {
      translate: 'Translate',
      export: 'Export',
      createAccount: 'Create account',
    },
    gate: {
      export: {
        title: 'Create your account to download',
      },
      translate: {
        title: 'Create your account to translate',
      },
      subtitle: 'Free, in 30 seconds. Your edited subtitles come with you.',
      features: {
        downloadLead: 'Download',
        downloadText: 'your subtitles in SRT, VTT, TXT and DOCX',
        translateLead: 'Translate',
        translateText: 'into 100+ languages in one pass',
        keepLead: 'Keep & publish',
        keepText: '— subtitles burned into the Videas player',
      },
      keep: 'Your work on “{name}” is kept and attached to your account.',
      defaultFile: 'your file',
      cta: 'Create my free account',
      haveAccount: 'Already have an account?',
      login: 'Log in',
      later: 'Keep editing',
    },
    nospeech: {
      title: 'No speech in this file',
      message:
        'We found nothing to transcribe — the file is silent, or carries no speech. Check that it has an audio track, then try again.',
      cta: 'Try another file',
    },
    error: {
      title: 'Something went wrong',
      message: "We couldn't generate subtitles for this file.",
      retry: 'Try another file',
    },
    timeout: {
      title: 'Still working on it',
      message: 'This is taking longer than usual. You can keep waiting, or come back in a moment.',
      keepWaiting: 'Keep waiting',
    },
    nodata: {
      title: 'No file to subtitle',
      subtitle: 'Upload a video to get automatic subtitles.',
      cta: 'Get started',
    },
  },
}
